import { YesNoRadio } from "$components/rhf/yes-no-radio";
import { styled } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { FormattedMessage } from "react-intl";

const WhatsappContainer = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const MarketingConsent: FC = () => {
  return (
    <div data-testid="marketingContainer">
      <Typography variant="body1" paragraph>
        <FormattedMessage
          id="first-sign-in.marketing.request"
          defaultMessage="Elephant would like to contact you with relevant product and feature updates that it thinks will be helpful for you. You can change your answer at any time on your User Settings page."
        />
      </Typography>
      <WhatsappContainer>
        <Typography variant="body1" paragraph>
          <FormattedMessage
            id="first-sign-in.whatsapp.confirm"
            defaultMessage="Do you give your permission for Elephant to contact you via WhatsApp?"
          />
        </Typography>

        <YesNoRadio name="whatsappConsent" />
      </WhatsappContainer>
      <Typography variant="body1" paragraph>
        <FormattedMessage
          id="first-sign-in.marketing.confirmWhatsappEnabled"
          defaultMessage="Do you give your permission for Elephant to contact you via other means including email and SMS?"
        />
      </Typography>
      <YesNoRadio name="marketing" />
    </div>
  );
};
